import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetDeliveryDelegateModalComponent } from 'src/app/features/my-assets/asset-modals/asset-delivery-delegate-modal/asset-delivery-delegate-modal.component';

@Component({
  selector: 'assets-fllet-management-view',
  standalone: false,
  templateUrl: './assets-fleet-management-view.component.html',
  styleUrl: './assets-fleet-management-view.component.scss',
})
export class AssetsFleetManagementViewComponent {
  @Input() public assets: app.models.DriverAssetListModel[] = [];
  @Input() public requestAccessWarnings: string[] = [];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public navigateToDetailHandler: any;
  @Input() public activeContracts: boolean = true;

  constructor(
    private _router: Router,
    private _ngbModal: NgbModal
  ) {}

  redirectDocumentRequest(event: Event, contractId: string, assetId: string) {
    event.stopPropagation();
    this._router.navigate(['requests/new', contractId, assetId]);
  }

  openDelegateModal(event: Event, asset: app.models.AssetListModel) {
    event.stopPropagation();
    const modalRef = this._ngbModal.open(AssetDeliveryDelegateModalComponent, {
      scrollable: true,
    });
    modalRef.componentInstance.asset = asset;
  }
}
